import { add, isWithinInterval } from 'date-fns';

/**
 * Helper function that returns whether dueDate of a book is within 30 days
 * from now, aka as within 'end of cycle'
 *
 * @param dueDate
 * @returns
 */
var isWithinEoc = function isWithinEoc(dueDate) {
  if (!dueDate) {
    return false;
  }
  return isWithinInterval(dueDate, {
    start: new Date(),
    end: add(new Date(), {
      days: 30
    })
  });
};
export default isWithinEoc;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/utils/dist/esm/date/isWithinEoc.js
// module id = 2855
// module chunks = 11